

import { Home, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PageContainer } from "../../components/ui/PageContainer";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <PageContainer className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center px-4">
      <div className="text-center max-w-2xl">
        {/* Illustration */}
        <div className="relative w-64 h-64 mx-auto mb-8">
          <img
            src="/404-illustration.png"
            alt="Page non trouvée"
            className="object-contain"
          />
        </div>

        
        {/* Titre */}
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">
          Oups ! Page introuvable
        </h2>
        
        {/* Description */}
        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          La page que vous recherchez n'existe pas ou a été déplacée.
          Vérifiez l'URL ou retournez à l'accueil.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour
          </button>
          
          <button
            onClick={() => navigate("/")}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white rounded-xl font-semibold hover:bg-primary/90 transition-colors"
          >
            <Home className="w-4 h-4" />
            Accueil
          </button>
        </div>

        {/* Liens utiles */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-400 mb-4">Vous cherchez peut-être :</p>
          <div className="flex flex-wrap gap-3 justify-center">
            <button
              onClick={() => navigate("/products")}
              className="text-sm text-primary hover:underline"
            >
              Nos produits
            </button>
            <span className="text-gray-300">•</span>
            <button
              onClick={() => navigate("/categories")}
              className="text-sm text-primary hover:underline"
            >
              Catégories
            </button>
            <span className="text-gray-300">•</span>
            <button
              onClick={() => navigate("/contact")}
              className="text-sm text-primary hover:underline"
            >
              Nous contacter
            </button>
          </div>
        </div>
      </div>
    </PageContainer>
  );
}